export default __webpack_public_path__ + "1eb71eb0e9c1de6f575a06ddb642d7e8.woff";